import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  form: [],
  levelGroup: [],
  org: [],
  position: [],
  emp: [],
  appraisalType: [],
  structure: [],
  loadingStates: []
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'company_id'] }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    message: action.errorMessage
  }
}

const fetchFormStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    form: action.data
  }
}

const fetchFormFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    message: action.errorMessage
  }
}

const fetchLevelGroupStart = (state, action) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'level_group_id']
  }
}

const fetchLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    levelGroup: action.data
  }
}

const fetchLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    message: action.errorMessage
  }
}

const fetchOrgStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'org_id'] }
}

const fetchOrgSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    org: action.data
  }
}

const fetchOrgFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    message: action.errorMessage
  }
}

const fetchPositionStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'position_id'] }
}

const fetchPositionSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    position: action.data
  }
}

const fetchPositionFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    message: action.errorMessage
  }
}

const fetchEmpStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'emp_id'] }
}

const fetchEmpSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    emp: action.data
  }
}

const fetchEmpFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    message: action.errorMessage
  }
}

const fetchAppraisalTypeStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'value_list_id'] }
}

const fetchAppraisalTypeSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'value_list_id'),
    appraisalType: action.data
  }
}

const fetchAppraisalTypeFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'value_list_id'),
    message: action.errorMessage
  }
}

const fetchStructureStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'structure_id'] }
}

const fetchStructureSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'structure_id'),
    structure: action.data
  }
}

const fetchStructureFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'structure_id'),
    message: action.errorMessage
  }
}

const fetchDashboardOverallPerformaceStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchDashboardOverallPerformaceSuccess = (state, action) => {
  // let { records } = action
  return {
    ...state,
    loading: false,
    records: action.records
  }
}

const fetchDashboardOverallPerformaceFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_START:
      return fetchFormStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_SUCCESS:
      return fetchFormSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FAILED:
      return fetchFormFailed(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_START:
      return fetchLevelGroupStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_SUCCESS:
      return fetchLevelGroupSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FAILED:
      return fetchLevelGroupFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrgStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrgFailed(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START:
      return fetchPositionStart(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchPositionFailed(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_START:
      return fetchEmpStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_SUCCESS:
      return fetchEmpSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FAILED:
      return fetchEmpFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START:
      return fetchAppraisalTypeStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchAppraisalTypeSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchAppraisalTypeFailed(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START:
      return fetchStructureStart(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStructureSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStructureFailed(state, action)
    case actionTypes.FETCH_DASHBOARD_OVERALL_PERFORMANCE_START:
      return fetchDashboardOverallPerformaceStart(state, action)
    case actionTypes.FETCH_DASHBOARD_OVERALL_PERFORMANCE_SUCCESS:
      return fetchDashboardOverallPerformaceSuccess(state, action)
    case actionTypes.FETCH_DASHBOARD_OVERALL_PERFORMANCE_FAILED:
      return fetchDashboardOverallPerformaceFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
